//
import React from 'react';
import {PropTypes} from 'prop-types';
import Iframe from '../common/Iframe';
import PreferenceCenterAPI from '../../api/preferencecenter/PreferenceCenterAPI';

class PreferenceCenterDatiPersonali extends React.Component {
  constructor(props) {
    super(props);
    //
    this.state = {
      show: false,
      autoprofileFormAvailable: false
    };
  }

  componentDidMount() {
    this.loadAutoprofileFormAvailability().then(() => {
        if (this.autoprofileFormAvailable) {
          this.setState({
            show: true
          });
        }
      })
      .catch(() => {

      });
  }

  loadAutoprofileFormAvailability() {
    return PreferenceCenterAPI.getAutoprofileFormAvailability(this.props.idOptin, this.props.hash, this.props.idList, this.props.idForm).then((autoprofileFormAvailable) => {
      this.autoprofileFormAvailable = autoprofileFormAvailable;
      //
      //  console.log("autoprofileFormAvailable", autoprofileFormAvailable);
    });
  }

  render() {
    const src = '/frontend/autoprofile.aspx?idForm=' + encodeURIComponent(this.props.idForm) + 
      '&hash=' + encodeURIComponent(this.props.hash) + 
      '&email=' + encodeURIComponent(this.props.email) +
      '&idList=' + encodeURIComponent(this.props.idList) +
      '&msg=' + encodeURIComponent(this.props.msg) + 
      '&emb=1' + 
      ((this.props.msg == 0) ? '&p=1': '')
      ;

    if(this.state.show) {
      return(
        <div className="frontend-row frontend-box">
          <div className="pref-center_container_form-autoprofilazione">
            <Iframe src={src} width="100%"/>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
  
}

//  <iframe width="100%" src={src} onLoad={this.onIframeLoad} ref={this.iframeRef} scrolling="no"/>


PreferenceCenterDatiPersonali.propTypes = {
  idForm: PropTypes.number.isRequired,
  idOptin: PropTypes.number.isRequired,
  hash: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  idList: PropTypes.number.isRequired,
  msg: PropTypes.number
};

PreferenceCenterDatiPersonali.defaultProps = {
  msg: 0  //  se 0 => modalità preview
};

export default PreferenceCenterDatiPersonali;